import OutsideClickHandler from "react-outside-click-handler";
import { useTranslation } from "react-i18next";

const PromotionDetail = ({ show, setShow }) => {
  const { t } = useTranslation();
  return (
    <div
      role="document"
      tabIndex={0}
      className="v-dialog__content v-dialog__content--active"
      style={{ zIndex: 202 }}
    >
      <div
        className="v-dialog v-dialog--active v-dialog--persistent"
        style={{ transformOrigin: "center center", maxWidth: "1100px" }}
      >
        <div className="dialog-card v-card v-sheet theme--light">
          <div className="row no-gutters justify-space-between dialog-header">
            <div className="d-flex flex-column pl-6 py-4 col col-10">
              <label className="dialog-title text-capitalize d-block full-width white--text">
                {show?.title || t("Promotion")}
              </label>
            </div>
            <div className="d-flex justify-content-center align-content-center col col-2">
              <button
                type="button"
                onClick={() => setShow({})}
                className="v-icon notranslate full-width v-icon--link mdi mdi-close theme--light white--text dialog-close-icon"
              />
            </div>
          </div>

          <div className="row dialog-row no-gutters">
            <div className="container px-3 maxFrameHeight">
              <div
                className="cms_bonus_content text-left"
                style={{ width: "100%" }}
              >
                <div className="row no-gutters">
                  <div style={{ marginBottom: "10px" }} className="col col-12">
                    <div className="v-image v-responsive theme--light">
                      <div
                        className="v-responsive__sizer"
                        style={{ "padding-bottom": "37.0748%" }}
                      />
                      <div
                        className="v-image__image v-image__image--cover"
                        style={{
                          "background-image": `url("${process.env.REACT_APP_API_BASE_URL}${show?.descriptionImage}")`,
                          "background-position": "center center",
                        }}
                      />
                      <div className="v-responsive__content" />
                    </div>
                  </div>

                  {show?.promotionPeriod && (
                    <div className="col-sm-10 col-md-10 col-lg-10 col-12">
                      <p className="font-weight-bold mb-0">{t("PromotionPeriod")}</p>
                      <p>{show.promotionPeriod}</p>
                    </div>
                  )}
                </div>

                <div
                  className="row no-gutters en cms_bonus_content text-left"
                  dangerouslySetInnerHTML={{
                    __html: show?.description || "",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromotionDetail;
